import { Trans } from 'react-i18next';
import { Card, InfinityLoading, Text } from 'ui';

import { useGlobalSearchInfiniteQuery } from '../queries';
import { NoResultsItem } from '../search-items';
import { SearchResultItem, searchResultHeaders } from '../search-result-item';
import { type SearchItemTypeKey, getSearchResultPath } from '../search-result-routes';
import { SearchBox } from './search-box';

const isSearchItemTypeKey = (scope: string): scope is SearchItemTypeKey => scope in searchResultHeaders;

const RESULTS_QUERY_LIMIT = 20;

type P = {
  onNavigate: (path: string) => void;
  query?: string;
  scope: string;
};

const SearchResults = ({ onNavigate, query, scope }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching } = useGlobalSearchInfiniteQuery({
    filter: { query },
    pagination: { pageSize: RESULTS_QUERY_LIMIT },
    scope,
  });

  const results = data?.pages.flat() ?? [];
  const scopeType = isSearchItemTypeKey(scope) ? scope : undefined;

  return (
    <Card
      shrinkedLeft
      shrinkedRight
      title={
        <Text size="small" uppercase>
          <Trans>Results for</Trans>: &quot;{query}&quot; ({scopeType ? searchResultHeaders[scopeType] : undefined})
        </Text>
      }
    >
      {!scopeType && !isFetching ? <NoResultsItem /> : null}
      {scopeType
        ? results.map((item) => (
            <SearchBox
              key={item.id}
              onClick={() => {
                onNavigate(getSearchResultPath(scopeType, item));
              }}
            >
              <SearchResultItem itemProps={item} type={scopeType} />
            </SearchBox>
          ))
        : null}
      <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
    </Card>
  );
};

export default SearchResults;
